(function () {
  angular.module("akitabox.asset", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.constants",
    "akitabox.core.router",
    "akitabox.asset.detail",
    "akitabox.asset.list",
  ]);
})();
